export enum ENTERPRISE_PARTNER_ID {
  evee = 'evee',
  ovoEnergy = 'ovo-energy',
  rewiringAustralia = 'rewiring-au',
}

// from: packages/service/src/resolvers/groups.ts
export const ENTERPRISE_GROUPS_NAME_MAP: Record<string, string> = {
  [ENTERPRISE_PARTNER_ID.ovoEnergy]: 'OVO Energy',
  [ENTERPRISE_PARTNER_ID.evee]: 'Evee',
};
